import React from 'react';
import BlockchainWeb3PageComponent from '../components/SolutionsPage/BlockchainWeb3Page';

/**
 * BlockchainWeb3Page - Blockchain & Web3 Solutions page wrapper
 */
export default function BlockchainWeb3Page() {
  return <BlockchainWeb3PageComponent />;
}
